module.exports = __webpack_public_path__ + "static/media/rics.dacc355f.jpg";